<lib-renderer-container
  [params]="params"
  [tooltip]="params.value?.value?.name"
>
  &nbsp;
  <span class="display-value">{{ params.value?.value?.name }}</span>
  <mat-icon class="expand-icon" svgIcon="{{EsvgFiles.arrow_down}}" *ngIf="cellEditable()"
            (click)="startEdit($event)"></mat-icon>
</lib-renderer-container>
